import React, { Component } from 'react';
import styled from 'styled-components';
import { Row, Col } from 'react-flexbox-grid';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import TextField from 'material-ui/TextField';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form/immutable';
// import MSelect from '../../common/Select';
import MSelect from '../../../shared/components/Select';
import { DropdownSelect } from '@vds/selects';
import styles from '../../../shared/components/CountryListModal/style';
import Modal from '../../../shared/components/Modal';
import { Button } from '@vds/buttons';
import { dispatchPageView } from '../../../shared/Tagging/tagging';
import '../../../assets/ak-cached/2h/stylesheets/pages/DeviceUnauth.css';
import { isUnAuth } from '../../../shared/services/httpClient';

const NButton = styled(Button)`
 min-width: -webkit-fill-available,
`;

const StyledRow = styled(Row)`
margin-left:0px;
margin-right:0px;
`;

const StyledCol = styled(Col)`
width: 20%;
@media(max-width:700px){
  width:50%;
}
`;
class GridWallComponent extends Component {
  static childContextTypes = {
    muiTheme: PropTypes.object.isRequired,
  };

  constructor(Props) {
    super(Props);
    this.state = {
      selecteddeviceIndex: null,
      //deviceLisdata: this.props.deviceLisdata,  // Stop showing device in initial page load as per story
      deviceLisdata: [],
      brandType: '',
      deviceType: '',
      deviceName: '',
      openDeviceNotCompatible: false,
      deviceNotCompatibleData: null,
    };
  }

  componentDidMount() {
    if (typeof (window.vzdl) == "undefined") {
      console.log("vzdl not defined");
    }
    else {
      window.vzdl.page.name = "DeviceSelection";
      window.vzdl.page.detail = "Devices";
      window.vzdl.page.sourceChannel = "VZW";
      window.vzdl.page.displayChannel = "VZW";
      window.vzdl.page.flow = "intl itp cpc";
      window.vzdl.user.authStatus = isUnAuth() ? "anonymous" : "logged in";
      // window.vzdl.target.engagement.intent= "account management";
      // window.vzdl.user.authStatus= "logged in";
      // window.vzdl.env.businessUnit=  "wireless";
      dispatchPageView('DeviceSelection');
    }
  }

  getChildContext() {
    return {
      muiTheme: getMuiTheme(baseTheme),
    };
  }

  commonFilter = (filterName, filterValue, eventName, eventValue) => {
    const deviceSelectorList = this.props.deviceLisdata;
    const devicelist = deviceSelectorList.filter((item) => (
      item[filterName] && item[filterName].toLowerCase().indexOf((filterValue).toLowerCase()) !== -1
    ));
    const dataFilter = devicelist.filter((data) => (
      data[eventName] && data[eventName].toLowerCase().indexOf((eventValue).toLowerCase()) !== -1
    ));
    if (dataFilter.length !== 0) {
      this.setState({ deviceLisdata: dataFilter, brandFilterData: dataFilter });
    } else {
      this.setState({ deviceLisdata: [] });
    }
  }

  searchComonFilter = (eventName, value) => {
    const serachFilter = this.state.deviceLisdata.filter((data) => (
      data[eventName] && data[eventName].toLowerCase().indexOf((value).toLowerCase()) !== -1
    ));
    if (serachFilter.length !== 0) {
      this.setState({ deviceLisdata: serachFilter, brandFilterData: serachFilter });
    } else {
      this.setState({ deviceLisdata: [], inputValue: '' });
    }
  }

  brandFilter = (e) => {
    const deviceSelectorList = this.props.deviceLisdata;
    if (e.target.value) {
      if (this.state.deviceName) {
        this.searchComonFilter(e.target.name, this.state.deviceName);
      }
      if (this.state.deviceType) {
        this.setState({ brandType: e.target.value });
        if (e.target.value === 'Brand' && this.state.deviceType !== 'Device') {
          this.searchComonFilter('sorDeviceCategory', this.state.deviceName);
        } else {
          this.commonFilter('sorDeviceCategory', this.state.deviceType, e.target.name, e.target.value);
        }
      } else {
        const devicelist = deviceSelectorList.filter((item) => (
          item[e.target.name] && item[e.target.name].toLowerCase().indexOf((e.target.value).toLowerCase()) !== -1
        ));
        if (devicelist.length !== 0) {
          this.setState({ deviceLisdata: devicelist, brandType: e.target.value, brandFilterData: devicelist });
        }
      }
    } else {
      this.setState({ deviceLisdata: this.props.deviceLisdata });
    }
  }

  _onSubmit(data, url) {
    const selectedMtns = [
      {
        skuId: data?.childSkus[0]?.sorId,
        deviceName: data?.productDisplayName,
      },
    ];
    const postData = {selectedMtns, "goBack": this.props.deviceGoBackFlag};
    console.log("deviceGoBackFlag value 2", this.props.deviceGoBackFlag,postData);
    const deviceSubmitObject = { selectedMtns };
    this.props.actions.deviceCompatibleCheck(this.props, postData);
    this.props.actions.setSelectedMtnsValue(selectedMtns);
    // const inputEle = document.getElementById('deviceSubmitObject');
    // inputEle.value = JSON.stringify({ selectedMtns });
    // // document.getElementById('submitDevices').submit();
  }

  searchFilter = (e) => {
    this.state.inputValue = e.target.value;
    if (e.target.value) {
      if (this.state.brandType && this.state.deviceType) {
        const BrandData = this.state.brandFilterData.filter((deviceIteams) => (
          deviceIteams.brandName && deviceIteams.brandName.toLowerCase().indexOf((e.target.value).toLowerCase()) !== -1
        ));
        this.setState({ deviceLisdata: BrandData });
      } else {
        let storeData = this.props.deviceLisdata.filter((deviceIteams) => (
          deviceIteams[e.target.name] && deviceIteams[e.target.name].toLowerCase().indexOf((e.target.value).toLowerCase()) !== -1
          || deviceIteams.brandName && deviceIteams.brandName.toLowerCase().indexOf((e.target.value).toLowerCase()) !== -1
        ));

        if (storeData.length === 0) {
          storeData = this.props.deviceLisdata.filter((deviceIteams) => (
            deviceIteams.brandName && deviceIteams.brandName.toLowerCase().indexOf((e.target.value).toLowerCase()) !== -1
            || deviceIteams.productDisplayName && deviceIteams.productDisplayName.toLowerCase().indexOf((e.target.value).toLowerCase()) !== -1
          ));
        }
        if (storeData.length === 0) {
          storeData = this.props.deviceLisdata.filter((deviceIteams) => (
            deviceIteams.brandName && deviceIteams.productDisplayName && ((deviceIteams.brandName + deviceIteams.productDisplayName).toLowerCase().indexOf((e.target.value.replace(' ','')).toLowerCase())) !== -1
          ));
        }

        if (storeData.length !== 0) {
          this.setState({ deviceLisdata: storeData, deviceName: e.target.value });
        } else {
          this.setState({ deviceLisdata: [] });
        }
      }
    } else if (this.state.brandType || this.state.deviceType) {
      if (this.state.brandType && this.state.deviceType) {
        const BrandData = this.state.brandFilterData.filter((deviceIteams) => (
          deviceIteams.brandName && deviceIteams.brandName.toLowerCase().indexOf((e.target.value).toLowerCase()) !== -1
        ));
        this.setState({ deviceLisdata: BrandData });
      }
    } else {
      this.setState({ deviceLisdata: this.props.deviceLisdata });
    }
  }

  deviceFilter = (e) => {
    const deviceSelectorList = this.props.deviceLisdata;
    if (e.target.value) {
      if (this.state.deviceName) {
        this.searchComonFilter(e.target.name, this.state.deviceName);
      }
      if (this.state.brandType) {
        this.setState({ deviceType: e.target.value });
        if (e.target.value === 'Device' && this.state.brandType !== 'Brand') {
          this.searchComonFilter('brandName', this.state.brandType);
        } else {
          this.commonFilter('brandName', this.state.brandType, e.target.name, e.target.value);
        }
      } else {
        const devicelist = deviceSelectorList.filter((item) => (
          item[e.target.name] && item[e.target.name].toLowerCase().indexOf((e.target.value).toLowerCase()) !== -1
        ));
        if (devicelist.length !== 0) {
          this.setState({ deviceLisdata: devicelist, deviceType: e.target.value, brandFilterData: devicelist });
        }
      }
    } else {
      this.setState({ deviceLisdata: this.props.deviceLisdata });
    }
  }

  closeFun = () => {
    this.props.actions.deviceCompatibleBolleanAction(false);
  }

  render() {
    const { heading, brands, sorDeviceCategory, textField } = this.props.deviceData;
    const mobileView = window.innerWidth;
    return (
      <div className='grid'>
        <div className="mainDiv" data-testid="UnAuth">
          <StyledRow className="pad10 noBottomPad">
            <Col sm={12} lg={6} md={6}>
              <h1 className="fontSize_5 margin18 noSideMargin" dangerouslySetInnerHTML={{ __html: heading }} />
            </Col>
          </StyledRow>
          <StyledRow className="pad10 noBottomPad">
            <Col sm={12} lg={4} md={4}>
              <div className="clearfix">
                <label htmlFor="Type to search for device" className="fontSize_3 bold" style={{ color: '#727171' }}>{textField && textField[0] && textField[0].fieldLabel}</label>
                <TextField
                  data-testid="deviceName"
                  style={{ ...styles.parentDiv, marginBottom: '-15px' }}
                  inputStyle={{
                    ...styles.input,
                  }}
                  name="deviceName"
                  value={this.state.inputValue}
                  hintStyle={{ ...styles.hintStyle }}
                  // hintText="Country List..."
                  multiLine={false}
                  rows={2}
                  underlineStyle={styles.underlineDefault}
                  underlineFocusStyle={(styles.underlineFocus)}
                  onChange={(e) => { this.searchFilter(e); }}
                />
                <p style={{ fontSize: '12px', color: 'grey' }}>Only devices compatiable with Verizon international travel services will be listed.</p>
              </div>
            </Col>

            <Col sm={12} lg={4} md={4} >
              <form className={mobileView < 768 ? 'width75' : 'brandSelectMargin'} style={mobileView < 768 ? { marginBottom: '1rem' } : {}}>
                <DropdownSelect
                  data-testid="BrandDropdown"
                  id="brandName"
                  name="brandName"
                  borderStyle
                  className="fontSize_2"
                  required
                  // label="Brand"
                  errorText='Select a Brand'
                  error={false}
                  onChange={(e) => { this.brandFilter(e); }}
                  analyticstrack="brand_list"
                  data-track="brand_list"
                >
                  <option key="disabled" value="" dangerouslySetInnerHTML={{ __html: 'Brand' }} selected disabled hidden analyticstrack="select-e911-brand-list" data-track="select-e911-brand-list" />
                  {brands &&
                    brands.map((data) => (

                       data &&
                      <option
                        key={data}
                        value={data}
                        name="brandName"
                      //selected={this.state.brandType}
                      >
                        {data}
                      </option>

                    ))
                  }
                </DropdownSelect>
              </form>

            </Col>
            <Col sm={10} lg={4} md={4}>
              <form className={mobileView < 768 ? 'width75' : 'deviceSelectMargin'} >
                <DropdownSelect
                  data-testid="DeviceDropdown"
                  id="sorDeviceCategory"
                  name="sorDeviceCategory"
                  borderStyle
                  className="fontSize_2"
                  errorText='Select a Device'
                  error={false}
                  // label="Device"
                  onChange={this.deviceFilter}
                  analyticstrack="device_list"
                  data-track="device_list"
                >
                  <option key="disabled" value="" dangerouslySetInnerHTML={{ __html: 'Device' }} selected disabled hidden analyticstrack="select-e911-device-list" data-track="select-e911-device-list" />
                  {sorDeviceCategory &&
                    sorDeviceCategory.map((value) => (
                      value &&
                      <option
                        key={value}
                        value={value}
                        //selected={value}
                        className="config_option1"
                      >
                        {value}
                      </option>
                    ))
                  }
                </DropdownSelect>
              </form>
            </Col>
          </StyledRow>
          <StyledRow className="pad10 noBottomPad">
            <Col mdOffset={9} lgOffset={10} sm={12} lg={12} md={10}>
              <span className=" bold countText" style={{ fontSize: "0.8rem" }}>{`Showing ${this.state.deviceLisdata && this.state.deviceLisdata.length} items`}</span>
            </Col>
          </StyledRow>
          <StyledRow className="pad20 noBottomPad margin40 onlyBottomMargin">
            {this.state.deviceLisdata && this.state.deviceLisdata.map((deviceData, idx) => {

              let imgs = deviceData?.childSkus[0]?.imageUrlMap?.defaultImage;
              if (!imgs) imgs = "//ss7.vzw.com/is/image/VerizonWireless/" + deviceData?.productDisplayName.replace(" ", "");
              return (<StyledCol className={`positionRelative gridWallBorder colWidth ${this.state.selecteddeviceIndex === idx ? 'selected' : ''}`} key={'plans' + idx} onClick={() => this.setState({ selecteddeviceIndex: idx })}>
                <div className="pad12">
                  <div className="pad25 onlyBottomPad">
                    <img alt="" width="50px" height="100px" className="margin50 onlyLeftMargin" src={`${imgs}`} />
                    <p className="pad20 onlyTopPad" style={{ minHeight: '60px', lineHeight: "initial" }} >
                      <span dangerouslySetInnerHTML={{ __html: deviceData?.brandName }} className="fontsize4 bold" /><br />
                      <span dangerouslySetInnerHTML={{ __html: deviceData?.productDisplayName }} className="fontsize4 bold" />
                    </p>
                    <div className="textAlignCenter pad20 onlyTopPad">
                      <NButton
                        data-testid={'Device' + idx}
                        size="small"
                        inverted={false}
                        analyticstrack="device-selection-cta"
                        key={'button' + idx}
                        className="button secondary"
                        style={{ width: "90%", minWidth: "-webkit-fill-available" }}
                        onClick={() => { this._onSubmit(deviceData, this.props.deviceData.ctaList[0].ctaUrl); }} >
                        {this.props.deviceData.ctaList[0].ctaLabel}
                      </NButton>
                    </div>
                  </div>
                </div>
              </StyledCol>)
            })}
          </StyledRow>
          {this.props && this.props.compatiableCheckData && <Modal
            data-testid="compatiablecheckmodal"
            mounted={this.props.deviceCompatibleFlag}
            style={{ maxWidth: 450 }}
            showCloseX = {true}
            closeFn={() => this.closeFun()}
            taggingId="compatiable-check-modal"
          >
            <div className="pad20 onlyRightPad">
              <div className="onlyBottomPad border_bottom_thick">
                <h2 className="pad6 onlyBottomPad" style={{ fontSize: "2.8rem" }}>{this.props && this.props.compatiableCheckData && this.props.compatiableCheckData.deviceCompatibleCheck && this.props.compatiableCheckData.deviceNotCompatible.heading}</h2>
              </div>
              <div className="pad24 noSidePad">
                <p>{this.props && this.props.compatiableCheckData && this.props.compatiableCheckData.deviceNotCompatible && this.props.compatiableCheckData.deviceNotCompatible.subHeading[0] && this.props.compatiableCheckData.deviceNotCompatible.subHeading[0].subText}</p>
              </div>
              <div className="textAlignCenter pad36 onlyTopPad">
                <Button
                  data-testid="compatibleCloseButton"
                  size="small"
                  inverted={false}
                  analyticstrack="comptiable-cta"
                  className="button margin12 onlyRightMargin"
                  onClick={() => this.closeFun()}>
                  {this.props && this.props.compatiableCheckData && this.props.compatiableCheckData.deviceNotCompatible && this.props.compatiableCheckData.deviceNotCompatible.ctaList[0] && this.props.compatiableCheckData.deviceNotCompatible.ctaList[0].ctaLabel}
                </Button>
              </div>
            </div>
          </Modal>}
        </div>
      </div>
    );
  }
}

GridWallComponent.propTypes = {
  deviceData: PropTypes.object,
  deviceLisdata: PropTypes.array,
  deviceCompatibleCheck: PropTypes.object,
  deviceCompatibleBolleanAction: PropTypes.func,
  compatiableCheckData: PropTypes.object,
  deviceCompatibleFlag: PropTypes.bool,
};

export { GridWallComponent };
export default reduxForm({
  form: 'gridWall_page',
})(GridWallComponent);

